import { classNames } from 'primereact/utils';

interface SummaryCardProps {
  title: string;
  value: string | number;
  subtitle?: string;
  icon?: string;
  bgClass?: string;
  textClass?: string;
  onClick?: () => void;
}

const SummaryCard = (props: SummaryCardProps): JSX.Element => {
  const { title, value, subtitle, icon, bgClass, textClass, onClick } = props;

  return (
    <div
      className={classNames(
        'shadow-[0_0_20px_0_rgba(76,87,125,0.02)] rounded-2xl px-5 py-4 bg-white',
        bgClass,
        { 'hover:shadow-md hover:cursor-pointer transition-shadow': !!onClick }
      )}
      onClick={onClick}
    >
      <div className="flex items-center justify-between">
        <div>
          <div className={classNames('text-sm font-medium text-gray-500', textClass)}>{title}</div>
          <div className="text-3xl font-bold text-gray-800 mt-1">{value}</div>
          {subtitle && <div className="text-sm text-gray-500 mt-1">{subtitle}</div>}
        </div>
        {icon && (
          <div className={classNames('text-3xl opacity-60', textClass)}>
            <i className={icon} />
          </div>
        )}
      </div>
    </div>
  );
};

export default SummaryCard;
